import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { GenericResponse } from "../business-entities/generic-response";
import { DMSDefaultValuesViewModel, DMSNameDetails, TableNameDetails } from "../business-entities/dms-defaultvalues-view-model";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class DMSDefaultValuesDataService {
    constructor(private dataProvider: DataService) {
    }

    async getDMSDefaultValues(model: any): Promise<GenericResponse<Array<any>>> {
        return this.dataProvider.Post<GenericResponse<Array<any>>>(Urls.GetDMSDefaultValues, model).toPromise();
    }
    async GetDMSName(): Promise<GenericResponse<Array<DMSNameDetails>>> {
        return this.dataProvider.GetAll<GenericResponse<Array<DMSNameDetails>>>(Urls.GetDMSName).toPromise();
      }
    async GetTableName(): Promise<GenericResponse<Array<TableNameDetails>>> {
        return this.dataProvider.Get<GenericResponse<Array<TableNameDetails>>>(Urls.GetTableName).toPromise();
    }
    AddDMSDefaultValues(model: DMSDefaultValuesViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDMSDefaultValues, model).toPromise();
    }
    UpdateDMSDefaultValues(Model: DMSDefaultValuesViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateDMSDefaultValues, Model).toPromise();
    }
    DeleteDefaultDMSValues(RowId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteDefaultDMSValues, RowId).toPromise();
    }
}
